import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "../components/Logo";
import { TimerPanel } from "../components/TimerPanel";
import { api } from "../lib/api";

const SalonPantalla = () => {
  const { workshopId } = useParams();
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("hz_admin_token");
    if (!token) { setChecking(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        return api.get(`/timer/${workshopId}`);
      })
      .then(() => setChecking(false))
      .catch((e) => {
        if (e?.response?.status === 403) setDenied(true);
        if (e?.response?.status === 401) localStorage.removeItem("hz_admin_token");
        setChecking(false);
      });
  }, [workshopId]);

  if (checking) return <div className="flex min-h-screen items-center justify-center bg-hz-navy text-white"><Loader2 className="h-8 w-8 animate-spin" /></div>;
  if (!user) return <Navigate to={`/login?redirect=/salon/${workshopId}/pantalla`} replace />;
  if (denied) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-hz-navy px-4 text-center">
        <p className="text-lg font-bold text-white" data-testid="pantalla-denied">No tienes permiso para proyectar este taller.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-hz-navy p-6 text-white" data-testid="salon-pantalla">
      <div className="mx-auto max-w-5xl">
        <div className="flex items-center justify-center gap-3 opacity-90">
          <Logo variant="icon" className="h-10" />
          <div className="text-center">
            <p className="text-sm font-extrabold tracking-wide">HORIZONTE 2026</p>
            <p className="text-[10px] font-semibold uppercase tracking-widest text-white/60">Liderazgo con Visión Reformada</p>
          </div>
        </div>
        <div className="mt-6">
          <TimerPanel workshopId={workshopId} role={user.role} readOnly projection />
        </div>
      </div>
    </div>
  );
};

export default SalonPantalla;
